export const CMS_CTA_TYPES = {
  CLOSE_MODAL: 'ctaCloseModal',
  GENERAL: 'callToActionGeneral',
  OFFER_CHECKOUT: 'ctaOfferCheckout',
  RAF: 'ctaReferAFriend',
  URL: 'callToAction',
  YOUTUBE_VIDEO: 'ctaYoutubeVideo',
};
